import type {Dispatch, SetStateAction} from 'react';

/**
 * Merge a partial update into a two-level `{chatId: {key: T}}` state map, creating the
 * chat bucket and seeding the entry from `defaultValue` when absent. Shared by the
 * provider's per-image / per-animation / animation-creation loading-state setters so the
 * identical nested-spread lives in one place.
 */
export function mergeIntoNestedStateMap<T extends object>(
  setMap: Dispatch<SetStateAction<Record<string, Record<string, T>>>>,
  chatId: string,
  key: string,
  defaultValue: T,
  updated: Partial<T>
): void {
  setMap((prev) => {
    const current = prev[chatId]?.[key] ?? defaultValue;
    return {
      ...prev,
      [chatId]: {
        ...(prev[chatId] ?? {}),
        [key]: {...current, ...updated},
      },
    };
  });
}
